// /settings/letter-templates — «Шаблоны писем» (042: T019; FR-050; contracts/ui.md): общий маршрут
// списка (index) и страницы письма ($id). Право — mail.templates, только администратор. Без права
// раздела нет: «Страница не найдена», а не «Нет доступа» (ux CHK010) — сотрудник и внешний
// пользователь не узнают о нём из адреса; отказ сервер пишет в журнал. Крошки: «Настройки /
// Шаблоны писем».
import { createFileRoute } from '@tanstack/react-router';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/settings/letter-templates')({
  beforeLoad: requireSection('letterTemplates', { hidden: true }),
  staticData: { crumb: 'Шаблоны писем' },
});
